/**
 * The name corrections' reads (Linear PG-14, NT-14): ordinary catalog GETs; the five decisions (approve,
 * send back, our error, state check, needs state fix) are the named exception in `ein-correction-writes.ts`.
 * Split out of `catalog.ts` on file-size grounds only.
 *
 * The id is the API's own shape (`einc_` and a uuid), constrained so nothing else rides the detail entry.
 * Nothing is declared below the id: every decision is a POST, and no static word sits beside
 * the id upstream (recorded as an empty sibling survey in `upstream-siblings.ts`).
 */
import type { ReadRoute } from "./catalog";

const PAGINATION = ["page", "pageSize"] as const;

export const EIN_CORRECTION_READ_ROUTES: readonly ReadRoute[] = [
  { path: "/api/admin/ein-corrections", query: [...PAGINATION, "status"] },
  { path: "/api/admin/ein-corrections/:id{einc_[0-9a-f-]+}", query: [] },
];
